import React, { useEffect, useMemo, useState } from 'react'
import "jspdf-autotable";
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { usePermissionGuardRedirect } from '../../../hooks/usePermissionGuard';
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import { GetCommonContentReReg } from '../../../services/ProgrammeServices';
import { RenderSchool } from '../../../utils/CommonGroupingItem';
import { TABLE_ROWS_PER_PAGE } from '../../../utils/Constants';
import { exportTableData, handleTableScroll } from '../../../utils/commonFunction';
import PermissionsGate from '../../../utils/permissionGate';
import Str from "../../common/Str";
import Tablefilter from '../../common/Tablefilter';
import { TrimText } from '../../common/TrimText';
import { pmcStatus } from '../program/GroupItems';

function AssignedTable({data, loading}) {
    const [search, setSearch] = useState("");
    const [school, setSchool] = useState({ arr: [], checkObj: {} });
    const [schoolArr, setSchoolArr] = useState([]);

    useEffect(() => {
        handleTableScroll();
    }, [loading]);

    usePermissionGuardRedirect(['matpview']);

    useEffect(() => {
        GetCommonContentReReg().then(res =>
            setSchoolArr(res.data.school_type)
        ).catch(err => console.error("err in common data api :", err))
    }, [])

    const resetFilter = () => {
        setSearch("");
        setSchool({ arr: [], checkObj: {} });
    };

    const exportData = (fileType, fileName) => {
        try {
            Swal.fire({
                title: "File Downloading...",
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            let data = dataToRender();
            let header = ["Name", "Code", "SAQA Link", "Status", "#NQF", "School"];

            data = data?.map((row) => ({
                ...row,
                Name: row?.P_SAQA_Name ?? "-",
                Code: row?.P_Code ?? "-",
                "SAQA Link": row?.P_SAQA_Link ?? "-",
                Status: row?.status ?? "-",
                "#NQF": row?.P_NQF_Level ?? "-",
                School: row?.P_School ?? "-",
            }));

            // export table
            exportTableData(fileType, fileName, header, data);
            Swal.close()

        } catch (error) {
            Swal.close();
            Swal.fire({
                icon: "error",
                title: "Error"
            });
        }
    };

    const handleSearchFilter = (e) => {
        const value = e.target.value;
        setSearch(value);
    };

    const myNameFilter = (a, b) => {
        return a.SAQA_Name && a.SAQA_Name.toLowerCase() > b.SAQA_Name && b.SAQA_Name.toLowerCase() ? 1 : -1;
    };
    const myCodeFilter = (a, b) =>
        a.Code.toLowerCase() > b.Code.toLowerCase() ? 1 : -1;
    const myNQFFilter = (a, b) =>
        Number(a.NQF_Level) > Number(b.NQF_Level) ? 1 : -1;

    const columns = useMemo(() => [
        {
            name: "Name",
            selector: "P_SAQA_Name",
            sortable: true,
            wrap: true,
            sortFunction: myNameFilter,
            cell: (row) => (
                <PermissionsGate
                    scopes={["matpedit"]}
                    RenderError={() => <span className="feature-name"> <span className="textLimit100">{row.P_SAQA_Name}</span></span>}
                >
                    <Link
                        to={`/program-management-center/programmes/programme/open/${row.ProgrammeId}`}
                        title={row.P_SAQA_Name}
                        className="as-text-blue curser feature-name"
                    >
                        <span className="textLimit100">{row.P_SAQA_Name}</span>
                    </Link>
                </PermissionsGate>
            ),
        },
        {
            name: "Code",
            selector: "P_Code",
            sortFunction: myCodeFilter,
            sortable: true,
            cell: (row, index) => (
                <div className="ticket-id">
                    <span title={row.P_Code} className="overflow-ellipsis2">
                        {TrimText(row.P_Code, 10)}
                    </span>
                </div>
            ),
        },

        {
            name: "SAQA Link",
            selector: "P_SAQA_Link",
            sortable: true,
            wrap: true,
            cell: (row) =>
                row.P_SAQA_Link ? (
                    <a
                        href={
                            row.P_SAQA_Link.includes("http")
                                ? row.P_SAQA_Link
                                : "http://" + row.P_SAQA_Link
                        }
                        target={"_blank"}
                        className="as-text-blue curser"
                        title={row.P_SAQA_Link}
                    >
                        {TrimText(row.P_SAQA_Link, 15)}
                    </a>
                ) : (
                    "-"
                ),
        },
        {
            name: "Status",
            selector: "status",
            sortable: true,
            wrap: true,
            cell: (row) =>
                row?.status != null ? pmcStatus(row?.status && row?.status) : "-",
        },
        {
            name: "#NQF",
            selector: "P_NQF_Level",
            sortFunction: myNQFFilter,
            sortable: true,
            wrap: true,
            cell: (row) => <div title={row?.P_NQF_Level}>{row?.P_NQF_Level}</div>,
        },
        {
            name: "School",
            selector: "P_School",
            sortable: true,
            wrap: true,
            cell: (row) => row.P_School ? RenderSchool(row.P_School).html : "-",
        },
        {
            name: "Actions",
            selector: "",
            cell: (row) => (
                <div className="assessment-08">
                    <div className="as-buttons">
                        <PermissionsGate
                            scopes={["matpedit"]}
                            RenderError={() => (
                                <button
                                    className="btn btn-primary rounded-circle"
                                    title="Open"
                                    disabled
                                >
                                    <i className="fal fa-folder-open"></i>
                                </button>
                            )}
                        >
                            <Link
                                to={`/program-management-center/programmes/programme/open/${row.ProgrammeId}`}
                                className="btn btn-primary rounded-circle"
                                title="Open"
                            >
                                <i className="fal fa-folder-open"></i>
                            </Link>
                        </PermissionsGate>
                        <PermissionsGate
                            scopes={["matpadd"]}
                            RenderError={() => (
                                <button
                                    className="btn btn-primary rounded-circle"
                                    title="Open"
                                    disabled
                                >
                                    <i className="fal fa-folder-open"></i>
                                </button>
                            )}
                        >
                            <Link
                                to={`/program-management-center/programmes/programme/duplicate/${row.ProgrammeId}`}
                                className="btn btn-primary rounded-circle"
                                title="Duplicate"
                            >
                                <i className="fal fa-copy"></i>
                            </Link>
                        </PermissionsGate>
                    </div>
                </div>
            ),
        },
    ], []);

    const dataToRender = () => {
        let updatedData = [];
        let allData = data;
        if (search.length) {
            let tempCode = allData.filter((item) => {
                let includes =
                    item.Code &&
                    item.Code.toString().toLowerCase().includes(search.toLowerCase());
                if (includes) {
                    return includes;
                } else return null;
            });
            let tempName = allData.filter((item) => {
                let includes =
                    item.P_SAQA_Name &&
                    item.P_SAQA_Name.toString()
                        .toLowerCase()
                        .includes(search.toLowerCase());
                if (includes) {
                    return includes;
                } else return null;
            });
            let tempLink = allData.filter((item) => {
                let includes =
                    item.P_SAQA_Link &&
                    item.P_SAQA_Link.toString()
                        .toLowerCase()
                        .includes(search.toLowerCase());
                if (includes) {
                    return includes;
                } else return null;
            });
            let tempP_NQF_Level = allData.filter((item) => {
                let includes =
                    item.P_NQF_Level &&
                    item.P_NQF_Level.toString()
                        .toLowerCase()
                        .includes(search.toLowerCase());

                if (includes) {
                    return includes;
                } else return null;
            });
            let tempP_School = allData.filter((item) => {
                let includes =
                    item.P_School &&
                    item.P_School.toString().toLowerCase().includes(search.toLowerCase());
                if (includes) {
                    return includes;
                } else return null;
            });
            let tempP_Quality_Council = allData.filter((item) => {
                let includes =
                    item.P_Quality_Council &&
                    item.P_Quality_Council.toString()
                        .toLowerCase()
                        .includes(search.toLowerCase());
                if (includes) {
                    return includes;
                } else return null;
            });

            let tempdata = [
                ...tempCode,
                ...tempName,
                ...tempLink,
                ...tempP_NQF_Level,
                ...tempP_School,
                ...tempP_Quality_Council,
            ];
            let unique = [...new Set(tempdata)];

            updatedData = unique;
        } else {
            updatedData = allData;
        }

        if (school.arr.length) {
            let tempRole = updatedData;
            let tempSearch = tempRole.filter((item) => {
                const startsWith = school.arr.find(function (user, index) {
                    if (
                        user.toLowerCase() ==
                        (item.P_School ? item.P_School.toLowerCase() : "")
                    )
                        return item;
                });
                if (startsWith) {
                    return startsWith;
                } else return null;
            });

            updatedData = tempSearch;
        }

        if (search.length || school.arr.length) {
            return updatedData;
        } else {
            return data;
        }
    };
    return (
        <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">
            <div
                className="custom-table-div filter-search-icon card card-table-custom"
            >
                <div className="search-filter-div">
                    <div className="search-filter-div-left">
                        <div className="system-administration-table table-responsive">
                            <div className="table-responsive-div">
                                <div
                                    id="assessment-table-main_wrapper"
                                    className="dataTables_wrapper no-footer"
                                >
                                    <div
                                        id="assessment-table-main_filter"
                                        className="dataTables_filter"
                                    >
                                        <label>
                                            <input
                                                type="search"
                                                className=""
                                                placeholder="Search"
                                                aria-controls="assessment-table-main"
                                                onChange={handleSearchFilter}
                                                value={search}
                                            />
                                        </label>
                                        <div className="filter-eff filter-data-btn">
                                            <button className="filter-buttons">
                                                <i className="fal fa-filter"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="filter-button-group">
                                <div className="filter-scroll">
                                    <div className={`filter-scroll-inner  filter-custom-new`}>
                                        <Tablefilter
                                            filterName="School"
                                            optionArr={schoolArr}
                                            state={school}
                                            setState={setSchool}
                                            renderLabelFunction={RenderSchool}
                                        />
                                    </div>
                                </div>
                                <div className="reset-btn-group">
                                    <div className="button-reset dropdown-comman">
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => resetFilter()}
                                            title="Reset"
                                        >
                                            <i className="fal fa-redo"></i>Reset
                                        </button>
                                    </div>
                                    <div className="files-export-group">
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("xlsx", "PMC");
                                            }}
                                            title="Export spreadsheet"
                                        >
                                            <i className="fal fa-file-excel icon"></i>
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("csv", "PMC");
                                            }}
                                            title="Export CSV"
                                        >
                                            <i className="fal fa-file-csv icon"></i>
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("pdf", "PMC");
                                            }}
                                            title="Export PDF"
                                        >
                                            <i className="fal fa-file-pdf icon"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <DataTable
                    data={dataToRender()}
                    columns={columns}
                    pagination={true}
                    progressComponent={<SkeletonTicketList />}
                    progressPending={loading}
                    noDataComponent={Str.noRecord}
                    defaultSortAsc={true}
                    defaultSortField={"P_SAQA_Name"}
                    paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
                />
            </div>
        </div>
    )
}

export default AssignedTable